import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';

const NotFound = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
            <h2>Access not permitted. <Link to="/">Click here to go back to the main screen.</Link>....</h2>
        </div>
    </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/js/containers/NotFound.jsx